import script from "./ArtefactCandidateDebug.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtefactCandidateDebug.vue?vue&type=script&setup=true&lang=ts"

import "./ArtefactCandidateDebug.vue?vue&type=style&index=0&id=19bc2329&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19bc2329"]])

export default __exports__